module.exports = __webpack_public_path__ + "img/close-red.45201985.svg";